import { useEffect, useRef, useState } from 'react'
import { LocalStorageService, BranchOfficeService } from "../../../services"
import { BranchOfficeMultipleView } from "../../views"
import { ModalUtil } from "../../pures"
import { useHistory, useLocation } from "react-router-dom"
import { useTranslation } from 'react-i18next'

const BranchOfficeMultipleAction = () => {
  const { t: transl } = useTranslation('branch-office', { keyPrefix: 'branchOfficeDetails' });
  const { t } = useTranslation()

  const history = useHistory()
  const uploadRef = useRef(null)

  const modalUtil = new ModalUtil()

  const modalError = () => {
    modalUtil.showModal('error', 'Ha ocurrido un error, vuelva a intentarlo', 'Operación fallida')
  }

  const modalSuccess = async () => {
    await modalUtil.showModal('success', 'Se ha cargado las sucursales con exito', 'Operación exitosa')
    history.push('/branch-offices-administration')
  }

  return <BranchOfficeMultipleView
    uploadRef={uploadRef}
    modalError={modalError}
    modalSuccess={modalSuccess}
  />
}

export default BranchOfficeMultipleAction